// extracted by mini-css-extract-plugin
export default {"slider":"styles_slider__xzIDw","slide":"styles_slide__Pzg+J"};